import React, {Fragment, useContext, useState, useEffect } from "react";
import {
    Button,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    ModalHeader,
} from "reactstrap";
import { RootStoreContext } from "../../core/store/rootStore";
import LoadingOverlay from "react-loading-overlay";
import "./user.css";

const TokenModal = () => {
    const rootStore = useContext(RootStoreContext);
    const { generalLoading, getToken } = rootStore.userStore;
    const { closeModal, modal } = rootStore.modalStore;

    let [token, setToken] = useState(null);

    useEffect(() => {
        if (modal.content && modal.content.id) {
            let userId = modal.content.id;

            getToken(userId).then(tokenResult => {
                setToken(tokenResult);
            });
        }
    }, [modal.content.id]);

    return (
        <Fragment>
            <Form>
                <LoadingOverlay active={generalLoading}
                                spinner>
                    <ModalHeader>Token</ModalHeader>
                    <ModalBody>
                        <FormGroup row>
                            <div className="col-12 full-text">
                                {token}
                            </div>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={closeModal}>
                            Annuler
                        </Button>
                    </ModalFooter>
                </LoadingOverlay>
            </Form>
        </Fragment>
    );
};

export default TokenModal;
